import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import CalenderData from "../dataViewer/CalenderData";
import Bridge from "../../utils/Bridge";
import moment from "moment";
import { HiOutlineNewspaper } from "react-icons/hi";
import { RESEARCH_TYPE } from "../../utils/consts";
import englishJson from "../../utils/language/leStudy/english.json";
import spanishJson from "../../utils/language/leStudy/spanish.json";
import noLanguageJson from "../../utils/language/leStudy/noLanguage.json";

const PersonalDataViewer = (props) => {
  const formData =
    RESEARCH_TYPE === "LE Study"
      ? props.language === "English"
        ? englishJson
        : props.language === "Spanish"
          ? spanishJson
          : noLanguageJson
      : englishJson;
  // state list
  const [calenderLoading, setCalenderLoading] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [lastSessionDate, setLastSessionDate] = useState("");
  const [upcomingSession, setUpcomingSession] = useState("");

  useEffect(() => {
    getLeStudySessions();
  }, []);

  const getLeStudySessions = () => {
    setCalenderLoading(true);
    let params = `?eals_id=` + localStorage.getItem("ap_eals_id");
    Bridge.personal_data_viewer.le_study
      .get_le_study_session_list(params)
      .then((res) => {
        let list = res.data.sort(
          (a, b) => new Date(b.date_created) - new Date(a.date_created)
        );
        let firstRecord = list.length > 0 ? list[0] : null;
        if (res.status == 1) {
          // setSessions(list);
          let lastSessionDateValue =
            list.length > 0
              ? moment(firstRecord.date_created).format("MM/DD/YYYY")
              : "";
          setLastSessionDate(lastSessionDateValue);

          if (lastSessionDateValue) {
            let upcomingSession = moment(lastSessionDateValue)
              .add(15, "days")
              .format("MM/DD/YYYY");
            setUpcomingSession(upcomingSession);
          }
          setSessions(res.data);
          setCalenderLoading(false);
        } else {
          setCalenderLoading(false);
        }
      })
      .catch((error) => {
        setCalenderLoading(false);
      });
  };
  const nextSessionButtonStyles = {
    fontSize: 24,
    marginRight: 10,
  };
  return (
    <div>
      <div className="row">
        <div className="col-lg-7">
          <Spin spinning={calenderLoading}>
            {sessions && sessions.length > 0 && (
              <CalenderData sessions={sessions} type="LE Study" />
            )}
            {sessions.length == 0 && (
              <CalenderData sessions={sessions} type="LE Study" />
            )}
          </Spin>
        </div>
        <div className="col-lg-5">
          <Spin spinning={calenderLoading}>
            <div className="card-wrapper update-details-card">
              <p className="mb-0">
                {formData.page.personalDataViewer.lastSession}:{" "}
                {lastSessionDate ? lastSessionDate : "--"}
              </p>
            </div>

            <div className="card-wrapper update-details-card mt-3">
              <p className="mb-0">
                {formData.page.personalDataViewer.upcomingSession}:{" "}
                {upcomingSession ? upcomingSession : "--"}
              </p>
            </div>

            <a
              href={"/download-everything-als-app"}
              className="red_big_button d-flex text-center justify-content-center align-items-center w-100"
              style={{ marginTop: 20 }}
            >
              <HiOutlineNewspaper style={nextSessionButtonStyles} />{" "}
              {formData.page.personalDataViewer.startMyNextSession}
            </a>

            {props.onOpenPrintReport && (
              <button
                onClick={props.onOpenPrintReport}
                className="red_big_button d-flex text-center justify-content-center align-items-center w-100"
                style={{ marginTop: 20 }}
              >
                <box-icon name="printer" color="#fff" size="24px"></box-icon>
                <span style={{ marginLeft: 10 }}>{formData.page.personalDataViewer.printMyReport}</span>
              </button>
            )}
          </Spin>
        </div>
      </div>
    </div>
  );
};

export default PersonalDataViewer;
